<!---job list -->
<div class="dashboard_bred_crumb">
    <ul>
        <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
        <li><a>Course Listing</a></li>
    </ul>
</div>

<section class="dashboard_content_sec">
    <section class="master_add_sec filterSec">

        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 20px;">
            <div class="search-container">
                <input type="text" name="search" class="search-input"
                    placeholder="Search by Course name, Company, Presenter" [formControl]="searchControl" />
                <img src="../../../../../../../assets/images/icons/search_grey.svg" alt="Search" class="search-icon" />
            </div>

            <div class="search-box">
                <button type="button" class="table-filter-btn" (click)="toggleFilter()"
                    style="display: flex; align-items: center;">
                    <img src="../../../../../assets/images2/Funnel.svg" alt="Filter" width="16" height="16"
                        style="margin-right: 5px;" />
                    Filter
                </button>
            </div>
        </div>

        <section *ngIf="openFilter" class="basic-filter openclose-filter-sec">


            <div class="filter-row">


                <div>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Type</mat-label>
                        <input matInput placeholder="Search Type" [matAutocomplete]="typeAuto"
                            (input)="onTypeInput($event.target.value)" [(ngModel)]="filterType">
                        <mat-autocomplete #typeAuto="matAutocomplete"
                            (optionSelected)="onTypeSelected($event.option.value)">
                            <mat-option *ngFor="let type of filteredCourseTypes" [value]="type.name">
                                {{ type.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <div class="dropdown-container">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Categories</mat-label>
                        <input matInput placeholder="Search Categories" [matAutocomplete]="categoryAuto"
                            (input)="onCategoryInput($event.target.value)" [(ngModel)]="filterCategory">

                        <mat-autocomplete #categoryAuto="matAutocomplete"
                            (optionSelected)="onCategorySelected($event.option.value)">
                            <mat-option *ngFor="let cat of filteredCourseCategories" [value]="cat.name">
                                {{ cat.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>


                <!-- Month Filter -->
                <div>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Date (YYYY-MM-DD)</mat-label>

                        <!-- Show selected date -->
                        <input matInput [matDatepicker]="picker" placeholder="Choose date" [(ngModel)]="selectedMonth"
                            (dateChange)="chosenDateHandler($event.value)" readonly />

                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <!-- Clear Button -->
                <div style="flex: 0 0 auto;">
                    <button mat-button class="clear-btn" type="button" (click)="clearAllFilters()">Clear</button>
                </div>
            </div>
        </section>

    </section>

    <div infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="200" (scrolled)="onScroll()">

        <section class="master_add_sec" *ngFor="let x of registeredCourses;">
            <mat-card class="job-card" fxLayout="column" fxLayoutGap="16px">
                <!-- Row: Avatar + Content -->
                <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start">
                    <!-- Avatar -->
                    <div class="avatar">
                        <img *ngIf="x?.presented_by_image?.url" src="{{x?.presented_by_image?.url}}" alt="Avatar"
                            loading="lazy" />
                    </div>

                    <div fxFlex class="content-box" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
                        <!-- Top Row -->
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="top-row">
                            <div class="title" *ngIf="x?.course_name || x?.created_at">
                                <strong class="title_head" *ngIf="x?.course_name">
                                    {{ x?.course_name }}
                                </strong>
                            </div>
                            <div>
                                <span class="date" *ngIf="x?.created_at">
                                    Posted on : {{ x?.created_at | date:'dd-MM-yyyy' }}
                                </span>
                            </div>
                        </div>

                        <!-- Course Name -->
                        <div class="company-name" *ngIf="x?.presented_by_name">
                            {{ x?.presented_by_name }}
                        </div>
                        <!-- cpd Hours -->
                        <div class="" *ngIf="x?.cpd_points">
                            CPD POINTS : {{ x?.cpd_points }}
                        </div>

                        <!-- Chips  Applicants -->
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="chip-row">
                            <mat-chip-list class="chip-list" aria-label="Job Types" *ngIf="x?.type">
                                <mat-chip>{{ x?.type }}</mat-chip>
                            </mat-chip-list>
                        </div>

                        <div *ngIf="x?.webinar_link" class="webinar-link-container">
                            <span class="label">Meeting Link : </span>
                            <a [href]="x?.webinar_link" target="_blank" rel="noopener noreferrer">{{
                                x?.webinar_link}}</a>
                        </div>
                    </div>
                </div>

                <div class="inner-divider"></div>

                <div class="view-details" fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center"
                    [routerLink]="['/learning/learning-hub-details', x.id]">
                    <span>View Details</span>
                    <mat-icon>chevron_right</mat-icon>
                </div>
            </mat-card>
        </section>

        <!-- Show "No registered courses" only after initial load completes and no data -->
        <div *ngIf="initialLoadDone && !loading && registeredCourses.length === 0" class="no-data"
            style="height: 30rem;">
            No registered courses found.
        </div>

        <!-- Show "No more courses to load" only after scrolling finishes -->
        <div *ngIf="initialLoadDone && allDataLoaded && registeredCourses.length > 0" class="no-data"
            style="padding-bottom: 20px;">
            No more courses to load.
        </div>
    </div>
</section>